<template>
  <el-dialog
    v-model="formVisible"
    :title="
      '车辆人员' + (status === 1 ? '新增' : status === 2 ? '编辑' : '详情')
    "
    @close="close"
    width="40%"
  >
    <div class="form_content">
      <h-anchor class="anchor" :idList="idList">
        <el-form
          ref="ruleFormRef"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
          class="userForm"
        >
          <div id="one">
            <div class="formTitle"><span></span>车辆信息</div>
            <el-row>
              <el-col :span="24">
                <el-form-item label="车牌号" prop="carNumber">
                  <el-row>
                    <el-col :span="5">
                      <h-selectcode
                        type="car_card_color"
                        v-model="ruleForm.carCardColor"
                        placeholder="车牌颜色"
                      ></h-selectcode>
                    </el-col>
                    <el-col :span="5">
                      <h-selectcode
                        type="plate_ownership"
                        v-model="ruleForm.carProvince"
                        placeholder="车牌省份"
                      ></h-selectcode>
                    </el-col>
                    <el-col :span="14">
                      <el-input
                        v-model="ruleForm.carNumber"
                        placeholder="车牌号"
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="车辆品牌" prop="">
                  <h-selectcode
                    type="vehicle_brand"
                    v-model="ruleForm.carBrand"
                    placeholder="车辆品牌"
                  ></h-selectcode>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆类型" prop="carType">
                  <h-selectcode
                    type="carType"
                    v-model="ruleForm.carType"
                    placeholder="车辆类型"
                  ></h-selectcode>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="车身颜色" prop="">
                  <h-selectcode
                    type="vehicle_color_six"
                    v-model="ruleForm.carColor"
                    placeholder="车身颜色"
                  ></h-selectcode>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="使用性质" prop="">
                  <h-selectcode
                    type="carUse"
                    v-model="ruleForm.function"
                    placeholder="使用性质"
                  ></h-selectcode>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div id="two">
            <div class="formTitle"><span></span>车主信息</div>

            <el-row>
              <el-col :span="24">
                <el-form-item label="机动车所有人" prop="name">
                  <el-input
                    disabled
                    v-model="ruleForm.name"
                    placeholder="机动车所有人"
                  >
                    <template #suffix>
                      <span class="iconClass" @click="iconClick">
                        <el-icon :size="20">
                          <edit />
                        </el-icon>
                      </span>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="证件号码" prop="">
                  <el-input
                    disabled
                    v-model="ruleForm.cardNumber"
                    placeholder="证件号码"
                  >
                    <template #prepend>
                      <!-- <el-form-item label="证件号码" prop="cardType"> -->
                      <h-selectcode
                        type="card_type"
                        :disabled="true"
                        v-model="ruleForm.cardType"
                        placeholder="证件类型"
                      ></h-selectcode>
                      <!-- </el-form-item> -->
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="lxdh">
                  <el-input
                    disabled
                    v-model="ruleForm.lxdh"
                    placeholder="联系电话"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="户籍行政区划" prop="">
                  <el-input
                    disabled
                    v-model="ruleForm.ghd"
                    placeholder="户籍行政区划"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="户籍详细地址" prop="">
                  <el-input
                    disabled
                    v-model="ruleForm.xxdz"
                    placeholder="户籍详细地址"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="初次登记日期" prop="">
                  <el-date-picker
                    v-model="ruleForm.createtime"
                    type="date"
                    placeholder="初次登记日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div id="three" style="height: 480px">
            <div class="formTitle"><span></span>其他信息</div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="发牌机关" prop="">
                  <el-input
                    v-model="ruleForm.carOffice"
                    placeholder="发牌机关"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </h-anchor>
    </div>
    <template #footer>
      <h-button type="primary" @click="submitForm(ruleFormRef)">保存</h-button>
      <h-button @click="formVisible = false">取消</h-button>
    </template>
  </el-dialog>
  <el-dialog v-model="ownerBinding" title="车主绑定" width="43%" height="40%">
    <ownerBinding
      v-model="ownerBinding"
      @submitList="submitList"
      :form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    ></ownerBinding>
  </el-dialog>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
} from "vue";
import util from "@util/js";
// import Validate from '@/utils/validate.js';
import { ElMessage } from "element-plus";
import { carsave, carupdate, carinfo } from "@/api/realHouse/realHouse.js";
import { Edit } from "@element-plus/icons-vue";
import ownerBinding from "./ownerBinding";
import _ from "lodash";
export default defineComponent({
  name: "CarpersonnelAdd",
  components: { Edit, ownerBinding },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const ruleFormRef = ref();
    const state = reactive({
      defaultPassword: "kzga110",
      formVisible: false,
      ownerBinding: false,
      passwordType: 1,
      idList: [
        { name: "车辆信息", id: "one", icon: "icon-shenfenzheng" },
        { name: "车主信息", id: "two", icon: "icon-invite" },
        { name: "其他信息", id: "three", icon: "icon-shuidianbiaoguanli" },
      ],
      ruleForm: {
        carCardColor: "",
        carProvince: "",
        carNumber: "",
        carBrand: "",
        carType: "",
        carColor: "",
        function: "",
        name: "",
        cardNumber: "",
        cardType: "",
        lxdh: "",
        ghd: "",
        xxdz: "",
        createtime: "",
        carOffice: "",
        prisonId: "",
      },
      ruleFormBack: {},
      rules: {
        carNumber: [
          {
            required: true,
            message: "请输入车牌号",
            trigger: "blur",
          },
        ],
        carType: [
          {
            required: true,
            message: "请选择车辆类型",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请选择所有人",
            trigger: "blur",
          },
        ],
      },
      options: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // state.ruleForm
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      console.log(" setup ~ props", props, context);
      state.formVisible = props.modelValue;
      // if (props.modelValue && types.includes(props.status)) {
      //   initForm();
      // }
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    watch(
      () => state.formVisible,
      (v) => {
        initForm();
      }
    );
    // 初始化表单
    const initForm = async () => {
      ruleFormRef.value && ruleFormRef.value.resetFields();
      if (props.status === 2) {
        let res;
        if (state.formVisible) {
          res = await carinfo(props.form.carId);
          if (res.carInfo.prisonInfo) {
            const val = [res.carInfo.prisonInfo];
            state.ruleForm.name = val[0].name;
            state.ruleForm.prisonId = val[0].prisonId;
            state.ruleForm.cardNumber = val[0].cardNumber;
            state.ruleForm.cardType = val[0].cardType;
            state.ruleForm.lxdh = val[0].telphone;
            state.ruleForm.ghd = val[0].registerName;
            state.ruleForm.xxdz = val[0].registerDetail;
          }
        }
        const form = { ...state.ruleForm, ...res.carInfo };
        state.ruleForm = _.cloneDeep(form);
      }
    };
    // 保存表单数据
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          util.formatForm(form);
          let res;
          if (props.status === 1) {
            res = await carsave(form);
          } else if (props.status === 2) {
            res = await carupdate(form);
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("submit");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };
    const iconClick = () => {
      state.ownerBinding = true;
    };
    const submitList = (val) => {
      state.ruleForm.name = val[0].name;
      state.ruleForm.prisonId = val[0].prisonId;
      state.ruleForm.cardNumber = val[0].cardNumber;
      state.ruleForm.cardType = val[0].cardType;
      state.ruleForm.lxdh = val[0].telphone;
      state.ruleForm.ghd = val[0].registerName;
      state.ruleForm.xxdz = val[0].registerDetail;
    };
    return {
      ...refData,
      submitList,
      submitForm,
      close,
      iconClick,
      ruleFormRef,
    };
  },
});
</script>
<style  lang='scss' scoped >
.form_content {
  max-height: 500px;
  overflow: auto;
  .anchor {
    max-height: 480px;
  }
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
}
.margLeftLabel {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
/deep/ .el-input-group__prepend {
  width: 150px;
  height: 100%;
  padding-right: 0px !important;
  box-sizing: border-box;
  .HSelectcode {
    width: 115% !important;
  }
}
.h-input {
  height: 29px !important;
  /deep/ .select-trigger {
    height: 100%;
    .el-input {
      height: 100%;
      .el-input__inner {
        height: 100%;
      }
    }
  }
}
.iconClass {
  cursor: pointer;
}
</style>